import {Links, MappedImage} from "../../utils/fw"
import { useSession } from "../utils"

import {UseHeartbeats} from "./HookWrappers"


export const Room = room => {
	const session = useSession()

	const [{
		"First & Last Name": name,
		"Registrant ID": userID,
		"Event Name": eventID,
		"Registrant Type": regType,
	}] = window.dataLayer

	return <div style="position: relative" {...room}>
		<UseHeartbeats
			page={room.name}
			data={{
				eventID,
				name,
				userID,
				regType,
				...(session && {session})
			}}
		/>
		<MappedImage imageURL={room.background}>
			<Links links={room.links} roomName={room.name} />
		</MappedImage>
		{room.extras}
	</div>
}
